import { filter } from 'lodash';

function filterStreams(streams: VideoStream[], streamStatus: "ALL" | "ACTIVE" | "ARCHIVED", selectedSite?: Site): VideoStream[] {
  return streamStatus === "ALL" ? filter(streams, { siteId: selectedSite?.siteId }) : filter(streams, { siteId: selectedSite?.siteId, state: streamStatus });
}

export default filterStreams;
